import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/ref/[username]/error.tsx");
